import { z } from "zod";
import { MediumText, idString } from "./common.js";
/**
 * Coaching Nudge — short, personal Player AI nudges. AI-populated content
 * registered as a real `WidgetKind` (mocked today; AIS swap is drop-in).
 * `askPrompt` seeds the "ask Player AI about this" follow-up. Rich seed content
 * lives in the mock; `defaultParams` is a skeleton.
 */
const CoachingNudgeSchema = z
    .object({
    id: idString,
    text: MediumText,
    askPrompt: MediumText,
})
    .strict();
export const CoachingNudgeParamsSchema = z
    .object({
    nudges: z.array(CoachingNudgeSchema).optional(),
})
    .strict();
export const defaultCoachingNudgeParams = { nudges: [] };
//# sourceMappingURL=coachingNudge.js.map